import { Env, readFromEnv } from '@cinch-nx/environments'
import { stripNonSearchQueryParametersFromUrl } from '../strip-non-search-query-parameters-from-url/strip-non-search-query-parameters-from-url'

export const getUsedCarsApiRequestUrlForUrlPath = (urlPath: string) => {
  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  const isNaturalLanguageSearchEnabled =
    readFromEnv(Env.EnableNaturalLanguageSearch) === 'true'

  const naturalLanguageQuery = isNaturalLanguageSearchEnabled
    ? new URLSearchParams(urlWithoutLeadingSlash.split('?')[1]).get('q')
    : null

  const urlWithNonSearchParamsRemoved = stripNonSearchQueryParametersFromUrl(
    urlWithoutLeadingSlash,
  )
  const searchServiceUrl = readFromEnv(Env.SearchServiceUrl)
  const baseUrl = `${searchServiceUrl}/used-cars?url=${encodeURIComponent(
    urlWithNonSearchParamsRemoved,
  )}`

  return naturalLanguageQuery
    ? `${baseUrl}&q=${encodeURIComponent(naturalLanguageQuery)}`
    : baseUrl
}
